export const CHART_OBJECTS_SETTINGS_STORAGE_KEYS = {
  OBJECTS: 'mt6_chart_objects'
} as const;
